import { render } from "./PodcastIcon.vue?vue&type=template&id=53f4c1fc&scoped=true"
import script from "./PodcastIcon.vue?vue&type=script&lang=js"
export * from "./PodcastIcon.vue?vue&type=script&lang=js"

import "./PodcastIcon.vue?vue&type=style&index=0&id=53f4c1fc&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3011205126/src/emulator.totogidemos.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f4c1fc"]])

export default __exports__